const ENUM_PRODUCT_COMPONENT = Object.freeze( {
  KAMISHIBAI: 'Kamishibai',
  FLASHMEETING: 'Flash Meeting',
  RESOLUTION: 'Résolution'
} );

export default ENUM_PRODUCT_COMPONENT;